const routeConfig = {
  login: '/',
  claimList: '/claim-list',
  claimWizard: '/wizard',
  postSubmit: '/post-submit',
};

export default routeConfig;



// WEBPACK FOOTER //
// ./app/utils/routeConfig.js